import React from 'react';

export default function DropdownSelect({ label, value, onChange, options = [], color = 'yellow' }) {
  const [open, setOpen] = React.useState(false);
  const selectedLabel = options.find((opt) => opt.value === value)?.label || 'Select';

  const colorMap = {
    yellow: {
      hover: 'hover:bg-yellow-500',
      selected: 'bg-yellow-200',
      ring: 'focus:ring-yellow-500',
    },
    purple: {
      hover: 'hover:bg-purple-500',
      selected: 'bg-purple-200',
      ring: 'focus:ring-purple-500',
    },
    green: {
      hover: 'hover:bg-green-600',
      selected: 'bg-green-200',
      ring: 'focus:ring-green-600',
    },
    pink: {
      hover: 'hover:bg-pink-500',
      selected: 'bg-pink-200',
      ring: 'focus:ring-pink-500',
    },
    teal: {
      hover: 'hover:bg-teal-600',
      selected: 'bg-teal-200',
      ring: 'focus:ring-teal-600',
    },
    sky: {
      hover: 'hover:bg-sky-100',
      selected: 'bg-sky-100',
      ring: 'focus:ring-sky-300',
    },
    red: {
      hover: 'hover:bg-red-500',
      selected: ' bg-red-100',
      ring: 'focus:bg-red-300',
    },
  };

  const hoverClass = colorMap[color]?.hover || 'hover:bg-yellow-100';
  const selectedClass = colorMap[color]?.selected || 'bg-yellow-50';
  const ringClass = colorMap[color]?.ring || 'focus:ring-yellow-500';


  return (
    <div className="relative">
      {label && <label className="mb-2 block text-sm font-bold text-gray-700">{label}</label>}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className={`flex w-full items-center justify-between rounded-xl border border-gray-300 bg-white px-4 py-2 text-left text-gray-800 shadow-sm focus:outline-none ${ringClass}`}
      >
        <span className="truncate text-sm font-medium text-gray-800">{selectedLabel}</span>
        <svg
          className={`w-4 h-4 text-gray-500 transition-transform ${open ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute z-10 mt-2 w-full rounded-xl border border-gray-200 bg-white shadow-lg">
          {options.map((opt) => (
            <div
              key={opt.value}
              onClick={() => {
                if (!opt.disabled) {
                  onChange(opt.value);
                  setOpen(false);
                }
              }}
              className={`cursor-pointer px-4 py-2 text-sm
                first:rounded-t-xl last:rounded-b-xl
                ${opt.disabled ? 'cursor-not-allowed text-gray-300' : hoverClass + ' text-gray-700'}
                ${value === opt.value ? selectedClass + ' font-semibold text-gray-900' : ''}`}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
